
export const getUserInfo = state => {
  return state.userInfo
}

export const getOrderData = state => {
  return state.orderData
}
export const getFulfillmentConfirmData = state => {
  return state.fulfillmentConfirmData
}
